import { useContext, useEffect, useRef, useState } from 'react';
import { FaEdit, FaEllipsisV, FaInfoCircle, FaMinusSquare, FaPlusSquare, FaTrashAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import SharedService from '../../../../services/SharedService';
import { ThemeContext } from '../../../../theme/ThemeContext';

const FaqCard = ({ item, activeIndex, toggleAccordion, deleteCard }) => {
  const navigate = useNavigate();
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const containerRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
   const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

  const toggleMenu = (e) => {
    e.stopPropagation();
    if (buttonRef.current && containerRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();
      setMenuPos({
        top: buttonRect.bottom - containerRect.top,
        left: buttonRect.left - containerRect.left - 120,
      });
    }
    setShowMenu((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };

    const handleScroll = () => setShowMenu(false);

    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showMenu]);

  const handleEdit = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    setTimeout(() => {
      navigate(
        `/masters-faq/edit/${SharedService.GenerateSlug(item.typeDesc)}/${SharedService.GenerateSlug(item.question)}`,
        { state: { id: item.id } }
      );
    }, 50);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    deleteCard(item.id);
  };

  return (
    <div className="position-relative" ref={containerRef}>
      <div className={`accordion-item border-0 shadow-sm ${activeIndex === item.id ? 'active' : ''}`}>
        <div className="d-flex">
          <div
            role="button"
            tabIndex={0}
            className={`accordion-header ${activeIndex === item.id ? 'active' : ''}`}
            onClick={() => toggleAccordion(item.id)}
             style={{ outline: 'none' }}  
            onKeyDown={(e) => e.key === 'Enter' && toggleAccordion(item.id)}
          >
            <div className="accordion-icon-wrapper">
              <FaInfoCircle
                size={20}
                color={activeIndex === item.id ? '#007bff' : '#9ca3af'}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <span className={`accordion-title ${activeIndex === item.id ? 'active' : ''}`}>
              {item.question}
            </span>
            <div className={`accordion-toggle ${activeIndex === item.id ? 'active' : ''}`}>
              {activeIndex === item.id ? <FaMinusSquare size={25} /> : <FaPlusSquare size={25} />}
            </div>
          </div>

          <button
            className="btn btn-sm border-0 text-primary pe-4 "
            ref={buttonRef}
            onClick={toggleMenu}
            type="button"
            style={{
    outline: 'none',
    boxShadow: 'none',
  backgroundColor: activeIndex === item.id
      ? isDark
        ? '#212529' 
        : '#f8f9fa' 
      : 'transparent',
  }}
          >
            <FaEllipsisV size={18} className="fw-normal" />
          </button>
        </div>

        <div className={`accordion-content ${activeIndex === item.id ? 'open' : ''}`}>
          <div className="accordion-content-inner">{item.answer}</div>
        </div>
      </div>

      {showMenu && (
        <div
          ref={menuRef}
          className="position-absolute"
          style={{
            top: `${menuPos.top}px`,
            left: `${menuPos.left}px`,
            minWidth: '160px',
            background: 'rgba(255,255,255,0.97)',
            backdropFilter: 'blur(6px)',
            borderRadius: '12px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            zIndex: 2000,
            padding: '8px 0',
            transform: 'translateY(8px)',
          }}
        >
          <button
            className="w-100 px-3 py-2 d-flex align-items-center gap-2 text-start border-0 bg-transparent"
            onClick={handleEdit}
            style={{ fontSize: '14px', color: '#333' }}
            type="button"
          >
            <FaEdit size={14} className="mb-1" /> Edit
          </button>
          <button
            className="w-100 px-3 py-2 d-flex align-items-center gap-2 text-start border-0 bg-transparent"
            onClick={handleDelete}
            style={{ fontSize: '14px', color: '#e63946' }}
            type="button"
          >
            <FaTrashAlt size={14} className="mb-1" /> Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default FaqCard;
